import React, { useEffect, useRef } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { withNamespaces } from 'react-i18next'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Button from '@material-ui/core/Button'
import { faFilter } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import i18next from 'i18next'
import Drawer from '@material-ui/core/Drawer'

import { DatePicker } from "@progress/kendo-react-dateinputs";
import { IntlProvider, LocalizationProvider } from "@progress/kendo-react-intl";
import InputLabel from '@material-ui/core/InputLabel';
import moment from "moment";
import "moment/locale/fr";
import { loadLocalization } from '../../utils/kendoLocalization';
import { Popup } from "@progress/kendo-react-popup";

import * as storage from '../../utils/storage'
import PropTypes from 'prop-types'
import styles from '../../styles/request.module.css'
import { IsEnglish, GetLanguage } from '../../utils/language';
import AlertAlgo from '../controls/AlertSnack'
import { isEmpty, convertToDate } from '../../utils';


loadLocalization();
moment.locale("fr");

const useStyles = makeStyles(theme => ({
    toolBar: {
        alignSelf: 'flex-end',
        color: "var(--color1) !important",
    },
    appBar: {

    },
    drawer: {
        '& .MuiDrawer-paper': {
            left: '40px !important'
        }
    },
    buttonFilter: {
        marginTop: '10px',
        border: '1px solid red'
    },
    divRoot: {
        padding: '5px'
    },
    divDate: {
        padding: '40px',
        '& > div > div table.k-calendar-weekdays': {
            width: '100%',
            marginLeft: '-4px'
        },
        '& > .k-month-calendar .k-calendar-td, .k-calendar-monthview .k-calendar-td': {
            marginLeft: '-1px'
        },
        '& > .k-calendar-weekdays + .k-scrollable > .k-calendar-table': {
            marginLeft: '20px'
        }
    },
    startDate: {
        marginBottom: '20px'
    }
}));

function FilterExpenseAccount(props) {
    const classes = useStyles();

    const [open, setOpen] = React.useState(false);
    const [startDate, setStartDate] = React.useState(new Date());
    const [endDate, setEndDate] = React.useState(new Date());
    const [locale, setLocale] = React.useState(GetLanguage());

    const [isFirst, setIsFirst] = React.useState(false);

    const { handleFilter } = props;

    const alertRef = useRef(null);

    useEffect(() => {
        setStartDate(new Date(startDate.setDate(startDate.getDate() - 90)));
        loadPage();
    }, [])

    useEffect(() => {
        // Workaround to pass the right parameters after the changing status on the page load

        if (isFirst) {
            handleFilter([startDate, endDate]);
        }
    }, [isFirst])

    const loadPage = async () => {
        await handleStorageFilter();
        setIsFirst(true);
    }

    const handleStorageFilter = () => {
        return new Promise(resolve => {
            const filter = storage.getFilterExpenseAccount();

            if (filter !== undefined) {
                setStartDate(new Date(filter.startDate));
                setEndDate(new Date(filter.endDate));
            }

            resolve();
        });
    }

    const handleOpenFilter = () => {
        setOpen(true);
    }

    const handleFilterSubmit = () => {
        if (isValid()) {
            handleFilter([startDate, endDate]);
            handleSaveStorageFilter();

            setOpen(false);
        }
    }

    const isValid = () => {
        let message = '';

        if (isEmpty(startDate)) {
            message = i18next.t('expenseAccount:filter.message.startDate');
        } else if (isEmpty(endDate)) {
            message = i18next.t('expenseAccount:filter.message.endDate');
        } else if (new Date(startDate) >= new Date(endDate)) {
            message = i18next.t('expenseAccount:filter.message.endDateGreaterThanStartDate');
        }

        if (message.length > 0) {
            showMessageError(message);
            return false;
        }

        return true;
    }

    const showMessageError = (message) => {
        alertRef.current.showMessageError(message);
    }

    const handleSaveStorageFilter = () => {
        const filter = {
            startDate: convertToDate(startDate),
            endDate: convertToDate(endDate)
        }

        storage.saveFilterExpenseAccount(filter);
    }

    const toggleDrawer = (open) => (event) => {
        // This is to avoid the drawer to close when we click within the filter div
        const role = event.currentTarget.attributes.role;
        if (role !== undefined && role.value === 'filter') {
            return;
        }

        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setOpen(open);
    };

    const onStartDateChange = (event) => {
        setStartDate(event.target.value);
    }

    const onEndDateChange = (event) => {
        setEndDate(event.target.value);
    }

    let _el;

    return (
        <div id="divFilterExpenseAccount" className={classes.divRoot}>
            <React.Fragment>
                <AppBar position="static" className={classes.appBar}>
                    <Toolbar className={classes.toolBar}>
                        <Button startIcon={<FontAwesomeIcon icon={faFilter} className="fa-w-16" />} color="inherit" onClick={handleOpenFilter}>{i18next.t('expenseAccount:filter.buttonFilter')}</Button>
                    </Toolbar>
                </AppBar>
                <Drawer anchor={'right'} open={open} onClose={toggleDrawer(false)} className={classes.drawer}>
                    <LocalizationProvider language={locale}>
                        <IntlProvider locale={locale}>
                            <div className={classes.divDate}>
                                <div className={classes.startDate} ref={el => (_el = el)}>
                                    <InputLabel className={"labelDatePicker required"} htmlFor="startDate">{i18next.t('expenseAccount:filter.startDate')}</InputLabel>
                                    <DatePicker
                                        className={styles.inputDate}
                                        name="startDate"
                                        value={startDate}
                                        onChange={onStartDateChange}
                                        format="yyyy-MM-dd"
                                        popup={props => <Popup {...props} appendTo={_el} />} />
                                </div>

                                <div className={classes.date} ref={el => (_el = el)}>
                                    <InputLabel className={"labelDatePicker required"} htmlFor="endDate">{i18next.t('expenseAccount:filter.endDate')}</InputLabel>
                                    <DatePicker
                                        className={styles.inputDate}
                                        name="endDate"
                                        value={endDate}
                                        onChange={onEndDateChange}
                                        format="yyyy-MM-dd"
                                        popup={props => <Popup {...props} appendTo={_el} />} />
                                </div>
                            </div>
                        </IntlProvider>
                    </LocalizationProvider>
                    <Button className={styles.buttonFilter} startIcon={<FontAwesomeIcon icon={faFilter} className="fa-w-16" />} color="primary" onClick={handleFilterSubmit}>{i18next.t('expenseAccount:filter.buttonFilter')}</Button>
                </Drawer>
            </React.Fragment>
            <AlertAlgo ref={alertRef} />
        </div>
    );
}

export default withNamespaces(['expenseAccount'], { wait: true })(FilterExpenseAccount);

FilterExpenseAccount.propTypes = {
    handleFilter: PropTypes.func.isRequired
}